import { withMetadata } from '../min/metadata'

import _getNumberType from '../es6/getNumberType'

export function getNumberType() {
	return withMetadata(_getNumberType, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/index.es6.exports/getNumberType.js
// module id = 641
// module chunks = 0